
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import withWidth, {isWidthUp} from '@material-ui/core/withWidth'
import AppBar from '@material-ui/core/AppBar'
import CircularProgress from '@material-ui/core/CircularProgress'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
// these icons will need to be replaced with icons found in mocks
import Description from '@material-ui/icons/Description'
import FindInPage from '@material-ui/icons/FindInPage'

import * as actions from '../../actionTypes'
import InitiateSessionForm from './InitiateSessionForm'
import RecallSessionForm from './recall-session/RecallSessionForm'
import ActionModal from '../common/ActionModal'


const styles = theme => ({
  appBar: {marginBottom: theme.spacing.unit * 5},
  root: {flexGrow: 1},
  tab: {width: '50%'},
  // muiTab class overrides
  label: {fontSize: '0.875rem'}, // fixes materialUI labelWrap fontSize adjustment bug
  progressIndicatorWrapper: {
    marginTop: 25,
    textAlign: 'center',
  },
  selected: {borderBottomWidth: 0},
  tabRoot: {borderBottom: `2px solid ${theme.palette.action.disabled}`}
})

class SetupContainer extends Component {
  state = {activeTabIndex: 0}

  componentDidMount() {
    this.initDecisions()
  }
  handleTabChange(activeTabIndex) {
    this.setState({activeTabIndex})
  }

  handleInitiateSessionFormChange = (field, formState) => {
    const { caseId, caseIdSuffix, caseIdPrefix, decisionId } = formState
    const mergedCaseId = `${caseIdPrefix}${caseId}${caseIdSuffix}`
    if(field === 'caseId' || field === 'decisionId') {
      if(decisionId && caseId.toString().length) {
        this.props.validateCaseId(mergedCaseId, decisionId)
      }
    }
    this.props.clearCaseIdErrors()
  }

  initDecisions() {
    const { lang, reRunDecisions } = this.props
    if(!this.props.availableDecisions[lang] || reRunDecisions) {
      this.props.getDecisions(lang)
    }
  }

  render() {
    const {availableDecisions, classes, isRequestingDecisions, isValidating, lang, t, width, errors, clearApiErrorText} = this.props
    const {activeTabIndex} = this.state
    const hasAvailableDecisions = !!availableDecisions[lang]
    const showProgressIndicator = activeTabIndex === 0 && isRequestingDecisions
    return (
      <div className={classes.root}>
        <AppBar
          className={classes.appBar}
          color="default"
          position="static"
        >
          <Tabs
            centered
            onChange={(event, value) => this.handleTabChange(value)}
            value={activeTabIndex}
          >
            <Tab
              classes={{
                label: classes.label,
                root: classes.tabRoot,
                selected: classes.selected
              }}
              className={classes.tab}
              icon={isWidthUp('sm', width) ? <Description/> : null}
              label={t('Start Session')}
            />
            <Tab
              classes={{
                label: classes.label,
                root: classes.tabRoot,
                selected: classes.selected
              }}
              className={classes.tab}
              icon={isWidthUp('sm', width) ? <FindInPage/> : null}
              label={t('Recall Session')}
            />
          </Tabs>
        </AppBar>
        {showProgressIndicator && (
          <div className={classes.progressIndicatorWrapper}>
            <CircularProgress style={{marginTop: 25}}/>
          </div>
        )}
        {activeTabIndex === 0 && hasAvailableDecisions && (
          <InitiateSessionForm
            availableDecisions={availableDecisions[lang]}
            errors={this.props.errors}
            isRequestingInitialization={this.props.isRequestingInitialization}
            isValidating={isValidating}
            onChange={this.handleInitiateSessionFormChange}
            onSubmit={(caseId, decisionId) => this.props.initializeSession(caseId, decisionId, lang)}
          />)}
        {activeTabIndex === 1 && (
          <RecallSessionForm availableDecisions={availableDecisions[lang]} />
        )}
        <ActionModal
          open={!!errors.apiErrorText}
          content={t(errors.apiErrorText)}
          dismissText={t('Continue')}
          onDismiss={clearApiErrorText}
        />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  clearCaseIdErrors() {
    const action = {type: actions.CLEAR_CASE_ID_ERRORS}
    dispatch(action)
  },
  getDecisions(lang) {
    const action = {type: actions.DECISIONS_REQUESTED, payload: {lang}}
    dispatch(action)
  },
  initializeSession(caseId, decisionId, lang) {
    const action = {type: actions.SESSION_INITIALIZE_REQUESTED, payload: {caseId, decisionId, lang}}
    dispatch(action)
  },
  recallSession(caseId, decisionId) { // Recall Session Stub
    const action = {}
    dispatch(action)
  },
  searchCaseIds(searchValue) {
    const action = {type: actions.CASE_ID_SEARCH_REQUESTED, payload: {}}
    dispatch(action)
  },
  validateCaseId(caseId, decisionId) {
    const action = {type: actions.CASE_ID_VALIDATION_REQUESTED, payload: {caseId, decisionId}}
    dispatch(action)
  },
  clearApiErrorText() {
    const action = { type: actions.SESSION_INITIALIZE_CLEAR_ERROR }
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  availableDecisions: state.setup.availableDecisions,
  errors: state.setup.initiateSession.errors,
  isRequestingDecisions: state.setup.initiateSession.isRequestingDecisions,
  isRequestingInitialization: state.setup.initiateSession.isRequestingInitialization,
  isValidating: state.setup.initiateSession.isValidating,
  lang: state.globalSettings.lang,
  reRunDecisions: state.setup.reRunDecisions,
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withStyles(styles),
  withWidth()
)(SetupContainer)



// WEBPACK FOOTER //
// ./src/components/setup/SetupContainer.js